import { jsx as _jsx } from "react/jsx-runtime";
import { useReducer } from 'react';
import { defaultState, GatewayConfigContext, GatewayContextReducer } from '../SytemManagement/Gateway/Context/gatewayContext';
import GatewayForm from './GatewayForm';
export const GatewayViewBase = (props) => {
    const [state, dispatch] = useReducer(GatewayContextReducer, defaultState);
    return (_jsx(GatewayConfigContext.Provider, { value: { state, dispatch }, children: _jsx(GatewayForm, { ...props }) }));
};
